export default __webpack_public_path__ + "static/media/fingerprintjs.9a028b94.png";